// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__wh5PK","calendarButtons":"ClockData_calendarButtons__1ClbC"};